import { useTranslation } from "react-i18next";
import Form from "react-bootstrap/Form";
import Card from "../Card/Card";
import ValidationError from "../ValidationError/ValidationError";
import { Option } from "../../generalTypes";

interface CardRadioSelectProps {
  title?: string;
  innerCard?: boolean;
  className?: string;
  options: Array<Option>;
  name: string;
  value: string;
  onChange: Function;
  disabled?: boolean;
  requiredText: string;
}

export default function CardRadioSelect(props: CardRadioSelectProps) {
  const { t } = useTranslation();

  return (
    <Card
      title={props.title}
      innerCard={props.innerCard}
      className={props.className}
    >
      {props.options.map((option, i) => (
        <Form.Group
          className={
            "row px-171-rem" +
            (i === 0 ? " pt-228-rem" : " pt-114-rem") +
            (i === props.options.length - 1 ? " radio-button-group-last" : "") +
            (props.value ? "" : " invalid")
          }
          key={i}
        >
          <Form.Check
            type="radio"
            className={
              "d-flex align-items-center p-0 radio-button-container" +
              (option.value === props.value ? " checked" : "")
            }
          >
            <Form.Check.Input
              className="p-071-rem ms-129-rem mt-0"
              type="radio"
              id={option.name}
              name={props.name}
              value={option.value}
              checked={option.value === props.value}
              onChange={(value) => {
                props.onChange(value);
              }}
              required
              disabled={props.disabled}
            />
            <Form.Label
              className={
                "font-weight-600 text-gray-36 p-129-rem m-0 radio-button-label" +
                (props.disabled ? " disabled" : "")
              }
              htmlFor={option.name}
            >
              {option.translateLabel ? t(option.label) : option.label}
            </Form.Label>
          </Form.Check>
        </Form.Group>
      ))}
      {!props.value && (
        <ValidationError
          text={props.requiredText}
          className="ps-171-rem pb-114-rem hidden-no-validation"
        />
      )}
    </Card>
  );
}
